import { formatPrice } from '../../dynamicBundle/index.js';
import { setSessionStorage, getSessionStorage } from '../../utils';
import {
  DROPDOWN_CONTAINER,
  DROPDOWN_LIST,
  DROPDOWN_LIST_OPEN,
  DROPDOWN_SELECT_OPTION,
  DROPDOWN_ITEM_SELECTOR,
  DROPDOWN_SELECT_OPTION_SELECTED,
  VOLUME_MENU_SELECTOR,
  VOLUME_RADIO_SELECTOR,
  VOLUME_RADIO_CHECKED,
  RECOMMENDATION_SELECTOR,
  KEY_VOLUME_BUNDLE_COMBOBOX_BUTTON,
  KEY_VOLUME_BUNDLE_RADIO,
  VOLUME_BUNDLE_ACTION,
  VOLUME_MENU_ITEM_SELECTOR,
} from '../constants';
import { updateVolumeBundleData } from '../services/bundle-data';
import { updateBundleUI } from '../ui/bundle-render';

/**
 * @type {import('../index.d').closeAllDropdown}
 */
export const closeAllDropdown = () => {
  const dropdowns = document?.querySelectorAll(`.${DROPDOWN_LIST}.${DROPDOWN_LIST_OPEN}`);

  dropdowns?.forEach(removeClassDropdownListOpening);
};

/**
 * @type {import('../index.d').toggleDropdown}
 */
export const toggleDropdown = (target) => {
  const targetDropdown = target?.closest(`.${DROPDOWN_CONTAINER}`);
  const isOpen = targetDropdown?.querySelector(`.${DROPDOWN_LIST_OPEN}`);

  closeAllDropdown();

  if (!isOpen) {
    targetDropdown?.querySelector(`.${DROPDOWN_LIST}`)?.classList?.add(DROPDOWN_LIST_OPEN);
  }
};

/**
 * @type {import('../index.d').removeClassDropdownListOpening}
 */
const removeClassDropdownListOpening = (dropdown) => {
  return dropdown?.classList?.remove(DROPDOWN_LIST_OPEN);
};

/**
 * @type {import('../index.d').handleDropdownToggle}
 */
export const handleDropdownToggle = (target, combobox) => {
  if (target?.closest(`.${DROPDOWN_SELECT_OPTION}`)) {
    combobox?.setAttribute('aria-expanded', 'true');
    toggleDropdown(target);
  } else {
    combobox?.setAttribute('aria-expanded', 'false');
    closeAllDropdown();
  }
};

/**
 * @type {import('../index.d').selectVariantProduct}
 */
export const selectVariantProduct = async (context, target, wrapper, position) => {
  const selectedVariantItem = target?.closest(DROPDOWN_ITEM_SELECTOR);
  if (!selectedVariantItem) return;

  const variantId = selectedVariantItem.dataset?.variantId;
  const productId = target?.closest(VOLUME_MENU_SELECTOR)?.dataset?.productId;
  const widgetId = target?.closest(RECOMMENDATION_SELECTOR)?.dataset?.widgetId;

  const targetDropdown = target?.closest('.boost-sd__dropdown-volume');
  const targetButtonText = targetDropdown?.querySelector('.boost-sd__dropdown-option-text');

  if (targetDropdown && selectedVariantItem) {
    targetDropdown
      .querySelectorAll(DROPDOWN_ITEM_SELECTOR)
      .forEach((item) => item.classList.remove(DROPDOWN_SELECT_OPTION_SELECTED));
    selectedVariantItem.classList.add(DROPDOWN_SELECT_OPTION_SELECTED);
    if (targetButtonText) targetButtonText.textContent = selectedVariantItem.textContent.trim();
  }

  target?.closest(`.${DROPDOWN_LIST_OPEN}`)?.classList?.remove(DROPDOWN_LIST_OPEN);

  const selectedRadio = target
    ?.closest(VOLUME_MENU_SELECTOR)
    ?.querySelector(`${VOLUME_RADIO_SELECTOR}.${VOLUME_RADIO_CHECKED}`);

  const selectedRadioId = selectedRadio ? selectedRadio.closest('input')?.id : null;

  setSessionStorage(
    KEY_VOLUME_BUNDLE_COMBOBOX_BUTTON,
    JSON.stringify({ variantId, productId, widgetId })
  );

  const updatedBundleData = await updateVolumeBundleData(
    context,
    widgetId,
    { optionData: { variantId, productId } },
    VOLUME_BUNDLE_ACTION.changeVariant,
    target,
    position
  );

  const widgetDesignSettings =
    context?.app?.recommendationWidgets?.['dynamic-bundle']?.[widgetId]?.widgetDesignSettings || {};
  const defaultOptionIndex = widgetDesignSettings.bundleHighlightOption;
  const defaultOptionId = updatedBundleData.bundleOptions[defaultOptionIndex - 1]?.id;

  const storedOptionId = getSessionStorage(KEY_VOLUME_BUNDLE_RADIO);

  const validOptionId =
    selectedRadioId && updatedBundleData.bundleOptions.some((opt) => opt.id === selectedRadioId)
      ? selectedRadioId
      : storedOptionId && updatedBundleData.bundleOptions.some((opt) => opt.id === storedOptionId)
        ? storedOptionId
        : defaultOptionId;

  if (selectedRadioId) {
    setSessionStorage(KEY_VOLUME_BUNDLE_RADIO, validOptionId);
  }

  updatedBundleData.bundleOptions = updatedBundleData.bundleOptions.map((option) => ({
    ...option,
    checked: option.id === validOptionId,
  }));

  updatedBundleData.bundleOptions = updatedBundleData.bundleOptions.map((option, index) => {
    const dropdownList = wrapper.querySelector(`#bundle-menu-item-${index + 1}`);

    const selectedDropdownItem = dropdownList?.querySelector(
      '.boost-sd__dropdown-volume-item.boost-sd__dropdown-option--selected'
    );

    const selectedVariantId =
      selectedDropdownItem?.dataset.variantId || updatedBundleData.matchedProduct.variants[0].id;

    const optionVariant =
      updatedBundleData.matchedProduct.variants.find(
        (variant) => variant.id === Number(selectedVariantId)
      ) || updatedBundleData.matchedProduct.variants[0];

    const originPrice = optionVariant.price;
    const currencyRate = Number(window.Shopify?.currency?.rate || 1);
    const discount = updatedBundleData.discounts.find((d) => d.item === option.items) || {};

    const rawDiscountedPrice =
      discount.discount_type === 'percentage'
        ? originPrice * option.items - (originPrice * option.items * discount.discount_value) / 100
        : Math.max(0, originPrice * option.items - discount.discount_value * currencyRate);

    const rawOriginalPrice = originPrice * option.items;

    return {
      ...option,
      selectedDropdownOptions: {
        variantId: optionVariant.id,
        discountedPrice: formatPrice(context, rawDiscountedPrice),
        originalPrice: formatPrice(context, rawOriginalPrice),
        rawDiscountedPrice,
        title: optionVariant.title,
        image: optionVariant.image || updatedBundleData.matchedProduct.images_info?.[0]?.src,
      },
    };
  });

  updatedBundleData.selectedOption = updatedBundleData.bundleOptions.find(
    (option) => option.checked
  );

  wrapper = target.closest(VOLUME_MENU_ITEM_SELECTOR);
  updateBundleUI(wrapper, updatedBundleData, target);
};
